import React, { useContext, useEffect } from 'react';
import PricingCard from './home_PricingCard';
import PricingComparison from './home_PricingComparison';
import { LanguageContext } from "../../context/LanguageContext";
import './home_Pricing.css';

const PricingPlans = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("PricingPlans", "home/home_PricingPlans_lang");
  }, [language]);

  const L = (componentLanguageData.PricingPlans || { Main: {} }).Main;

  const plans = [
    // 30 天試用
    {
      badgeLabel: L.Content1,        // 30 天試用中
      badgeColorClass: 'badge-dark',
      btnClass: 'btn-trial',
      monthlyPrice: 0,               // US$0 / 30 天
      annualPrice: null,
      subtitle: L.Content2,          // 免費體驗・完整走完流程
      priceId: 4,
      buttonText: L.Content3,        // 立即啟用
      features: [
        { text: L.CardFeat1, text_num_f: L.PerDay, num: "10", text_num_b: L.Times },
        { text: L.CardFeat2, text_num_f: L.PerDay, num: "5", text_num_b: L.Times },
        { text: L.CardFeat3, num: "5", text_num_b: L.Items },
        { text: L.CardFeat4, num: "3", text_num_b: L.TimesPerMonth },
        { text: L.CardFeat5, num: "1", text_num_b: L.Items },
      ]
    },

    // Starter
    {
      badgeLabel: L.Content4,        // Starter
      badgeColorClass: 'badge-orange',
      btnClass: 'btn-starter',
      monthlyPrice: 25,
      annualPrice: 250,
      subtitle: L.Content5,          // 策略入門・開始部署
      priceId: 1,
      buttonText: L.Content6,
      features: [
        { text: L.CardFeat1, text_num_f: L.PerDay, num: "30", text_num_b: L.Times },
        { text: L.CardFeat2, text_num_f: L.PerDay, num: "15", text_num_b: L.Times },
        { text: L.CardFeat3, num: "10", text_num_b: L.Items },
        { text: L.CardFeat4, num: "10", text_num_b: L.TimesPerMonth },
        { text: L.CardFeat5, num: "1", text_num_b: L.Items },
      ]
    },

    // Pro（最受歡迎）
    {
      badgeLabel: L.Content7,        // Pro
      badgeColorClass: 'badge-purple',
      btnClass: 'btn-pro',
      highlight: true,
      popularText: L.MostPopular,    // 最受歡迎
      monthlyPrice: 50,
      annualPrice: 500,
      subtitle: L.Content8,          // 專業策略・長期管理
      priceId: 2,
      buttonText: L.Content9,
      features: [
        { text: L.CardFeat1, text_num_f: L.PerDay, num: "60", text_num_b: L.Times },
        { text: L.CardFeat2, text_num_f: L.PerDay, num: "30", text_num_b: L.Times },
        { text: L.CardFeat3, num: "50", text_num_b: L.Items },
        { text: L.CardFeat4, num: "30", text_num_b: L.TimesPerMonth },
        { text: L.CardFeat5, num: L.Unlimited },
      ]
    }
  ];

  return (
    <div className="container-xxl py-5">
      <div className="container px-lg-5">
        <div className="section-title position-relative text-center mx-auto mb-5 pb-4 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '600px' }}>
          <h1 className="mb-3">{L.Title}</h1>
          <p className="mb-1" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
            {L.Description1}<br />
            {L.Description2}
          </p>
        </div>

        <div className="row gy-4 gx-4 justify-content-center align-items-stretch">
          {plans.map((plan, index) => (
            <PricingCard key={index} {...plan} />
          ))}
        </div>
      </div>

      <PricingComparison />
    </div>
  );
};

export default PricingPlans;
